import React from "react"
import TextField, { TextFieldProps } from "@mui/material/TextField"

const TextInput = ({ type = "text", ...props }: TextFieldProps) => {
	return (
		<TextField
			type={type}
			{...props}
			inputProps={{ "data-hj-whitelist": true, "data-hj-allow": true }}
			variant="outlined"
			margin="normal"
		/>
	)
}

export default TextInput
